<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission"
      v-bind:disable_page="disablePage">

      <h3>{{ pageTitle }}</h3>
      
      <AppForm
        v-show="pageShowData"
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput" />

      <TemplateFeedback ref="pageFeedback" />

      <button v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
        Cancel
      </button>
      <TemplateButton v-show="hasAddOrEditPermission()" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Save
      </TemplateButton>
      <button v-show="hasDeletePermission() && !pageIsAdd" v-on:click="onDeleteButtonClick" type="button" class="btn btn-danger">
        Delete
      </button>

      <TemplateModal
        v-bind:modalId="deleteModalId">
        <h4 slot="modal-title" class="modal-title" >
          {{ deleteModalTitle || 'Confirm Delete' }}
        </h4>
        <div slot="modal-body">
          {{ deleteModalBody || 'Are you sure you want to delete the selected item?' }}
          <br>
          <br>
          <TemplateFeedback ref="deleteFeedback" />
        </div>
        <div slot="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
          <button @click="onDeleteConfirmClick" type="button" class="btn btn-danger">
            Confirm
          </button>
        </div>
      </TemplateModal>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import TemplateModal from "@/components/Template/TemplateModal";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import CustomerCompanyParam from "@/components/Param/CustomerCompanyParam"

var querystring = require('querystring');

const ADDRESS_FIELD = ['companyAddress1','companyAddress2','companyAddress3','companyAddressPostalCode','companyAddressCityID','companyAddressStateID','companyAddressCountryID'];
const CONTACT_FIELD = ['companyTelephone', 'companyFax', 'companyPICname', 'companyPICphone', 'companyPICemail'];

const PARAM = CustomerCompanyParam.getParam();
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageCompanyForm",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    TemplateModal,
    AppForm,
  },
  data () {
    return {
      permission : null,
      disablePage: false,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Customer List' },
        { name: 'Company', url: '/company' },
      ],

      API_PATH: "/api2/customer/",

      PARAM,
      PARAM_MAP,

      deleteModalId: null,
      deleteModalTitle: null,
      deleteModalBody: null,
      
      pageIsAdd: true,
      pageTitle: null,
      pageShowData: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    PARAM_MAP['companyPICemail'].form_edit_input_attr = {
      'disabled' : 1,
    };

    if(helper.checkRoleIsParker()) {
      // PARAM_MAP['name'].text = 'Name';

      PARAM_MAP['companyPICemail'].form_default = JSON.parse(localStorage.getItem('user')).username;
      PARAM_MAP['companyPICemail'].form_input_attr = {
        'disabled' : 1,
      };

      // if(!helper.checkRoleHasCustomerID()) {
      //   // first time create personal profile
      // } else {
      //   // already has personal profile
      //   if(!this.$route.query.customerID) {
      //     // not allow parker with profile create again, disable
      //     this.disablePage = true;
      //     return;
      //   } else {
      //     // not allow parker to edit company reg no
      //     PARAM_MAP['nationalID'].form_input_attr = {
      //       'disabled' : 1,
      //     };
      //   }
      // }
    }
    
    this.deleteModalId = "jt-popup-modal-" + this._uid + '-delete';
    
    this.$nextTick(() => {
      helper.setSidebar('/company');
    });

    this.loadCountry();
  },
  methods: {
    loadCountry() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading country data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/country',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['companyAddressCountryID'], response.data);
          this.loadState();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'country data'));
        });
    },
    loadState() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading state data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/state',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['companyAddressStateID'], response.data);
          this.loadCity();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'state data'));
        });
    },
    loadCity() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading city data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/city',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['companyAddressCityID'], response.data);
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'city data'));
        });
    },

    loadData() {
      let customerID = this.$route.query.customerID;

      if(customerID) {
        this.pageIsAdd = false;
        this.$refs['pageFeedback'].setFeedbackLoading('Loading customer profile data...');
        
        this.$http
          .get(
            helper.SERVER_URL + this.API_PATH + customerID,
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            let tempData = response.data[0];
            if(tempData) {
              this.pageTitle = 'Edit ' + tempData.name;
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.loadDataComplete(tempData);
            } else {
              this.$refs['pageFeedback'].setFeedbackError('Problem loading customer profile data.');
            }
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer profile data'));
          })
      } else {
        this.pageIsAdd = true;
        this.pageTitle = 'Create New Company';
        this.loadEverythingComplete(true);
      }
    },
    loadDataComplete(tempData) {
      if(tempData.address1) {
        this.loadAddress(tempData);
      } else {
        this.loadEverythingComplete(false, tempData);
      }
    },
    loadAddress(tempData) {
      let feedback = 'car park address data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedback);
      
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + tempData.address1,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          tempData = Object.assign(helper.parseAddress(response), tempData);
          this.loadAddressComplete(tempData);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedback));
        })
    },
    loadAddressComplete(tempData) {
      if(tempData.contact1) {
        this.loadContact(tempData);
      } else {
        this.loadEverythingComplete(false, tempData);
      }
    },
    loadContact(tempData) {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading customer contact information...');
      
      this.$http
        .get(
          helper.SERVER_URL + '/api2/contact/' + tempData.contact1,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          tempData = Object.assign(helper.parseContact(response), tempData);
          this.loadContactComplete(tempData);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer contact information'));
        })
    },
    loadContactComplete(tempData) {
      this.loadEverythingComplete(false, tempData);
    },
    loadEverythingComplete(formIsAdd, formData) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageForm'].setForm(formIsAdd, formData);
      this.pageShowData = true;
    },

    onCancelButtonClick() {
      if(this.$route.query.redirect) {
        helper.redirect(this.$route.query.redirect);
      } else {
        helper.redirect(helper.WEB_URL + '/company');
      }
    },
    onSaveButtonClick() {
      if(!this.$refs['pageForm'].validateForm()) {
        this.upsertAddress({});
      }
    },
    onDeleteButtonClick() {
      let formData = this.$refs['pageForm'].formData;
      this.deleteModalTitle = `Confirm Delete ${formData.name}?`;
      this.deleteModalBody = `Are you sure you want to delete ${formData.name}?`;
      $('#' + this.deleteModalId).modal('show');
    },
    async onDeleteConfirmClick() {
      let formData = this.$refs['pageForm'].formData;
      let feedbackItem = formData.name;

      this.$refs['deleteFeedback'].setFeedbackLoading('Checking parking license data for ' + feedbackItem);
      if(!await this.$http
        .get(
          helper.SERVER_URL + '/api2/license?customerID=' + formData['id'],
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          response.data = response.data.filter(k => helper.compareID(k.customerID, formData['id']));
          return response.data.length === 0;
        })) {
        this.$refs['deleteFeedback'].setFeedbackError('This customer profile has associated parking license, unable to delete.');
        return;
      }

      this.$refs['deleteFeedback'].setFeedbackLoading('Checking parking license application data for ' + feedbackItem);
      if(!await this.$http
        .get(
          helper.SERVER_URL + '/api2/request?customerID=' + formData['id'],
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          response.data = response.data.filter(k => helper.compareID(k.customerID, formData['id']));
          return response.data.length === 0;
        })) {
        this.$refs['deleteFeedback'].setFeedbackError('This customer profile has associated parking license application, unable to delete.');
        return;
      }

      this.$refs['deleteFeedback'].setFeedbackLoading('Checking tenant data for ' + feedbackItem);
      if(!await this.$http
        .get(
          helper.SERVER_URL + '/api2/tenant?customerID=' + formData['id'],
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          response.data = response.data.filter(k => helper.compareID(k.customerID, formData['id']));
          return response.data.length === 0;
        })) {
        this.$refs['deleteFeedback'].setFeedbackError('This customer profile has associated car park, unable to delete.');
        return;
      }

      $('#' + this.deleteModalId).modal('hide');

      this.$refs['pageFeedback'].setFeedbackLoading('Deleting ' + feedbackItem);
      this.$http
        .delete(
          helper.SERVER_URL + this.API_PATH + formData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'deleting', feedbackItem));
        })
    },

    upsertAddress(data) {
      if(this.$refs['pageForm'].formIsAdd) {
        this.addAddress(data);
      } else {
        if(this.$refs['pageForm'].formData.address1) {
          this.addAddress(data);
          // this.editAddress(data);
        } else {
          this.addAddress(data);
        }
      }
    },
    addAddress(data) {
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + this.$refs['pageForm'].formData.name + ' address');

      let temp = {};
      ADDRESS_FIELD.forEach(k => temp[k] = this.$refs['pageForm'].formData[k]);
      
      this.$http
        .post(
          helper.SERVER_URL + '/api2/address/',
          querystring.stringify({'address': JSON.stringify(temp)}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          data.address1 = response.data;
          this.upsertAddressComplete(data, `Successfully added ${this.$refs['pageForm'].formData.name} address`);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', 'address data'));
        })
    },
    editAddress(data) {
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + this.$refs['pageForm'].formData.name + ' address');

      let temp = {};
      ADDRESS_FIELD.forEach(k => temp[k] = this.$refs['pageForm'].formData[k]);
      
      this.$http
        .post(
          helper.SERVER_URL + '/api2/address/' + this.$refs['pageForm'].formData.address1,
          querystring.stringify({'address': JSON.stringify(temp)}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          data.address1 = response.data;
          this.upsertAddressComplete(data, `Successfully update ${this.$refs['pageForm'].formData.name} address`);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', 'address data'));
        })
    },
    upsertAddressComplete(data, message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.upsertContact(data);
    },

    upsertContact(data) {
      if(this.$refs['pageForm'].formIsAdd) {
        this.addContact(data);
      } else {
        if(this.$refs['pageForm'].formData.contact1) {
          this.addContact(data);
          // this.editContact(data);
        } else {
          this.addContact(data);
        }
      }
    },
    addContact(data) {
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + this.$refs['pageForm'].formData.name + ' contact information');

      let temp = {};
      CONTACT_FIELD.forEach(k => temp[k] = this.$refs['pageForm'].formData[k]);
      
      this.$http
        .post(
          helper.SERVER_URL + '/api2/contact/',
          querystring.stringify({'contact': JSON.stringify(temp)}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          data.contact1 = response.data;
          this.upsertContactComplete(data, `Successfully added ${this.$refs['pageForm'].formData.name} contact information`);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', 'contact information'));
        })
    },
    editContact(data) {
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + this.$refs['pageForm'].formData.name + ' contact information');

      let temp = {};
      CONTACT_FIELD.forEach(k => temp[k] = this.$refs['pageForm'].formData[k]);
      
      this.$http
        .post(
          helper.SERVER_URL + '/api2/contact/' + this.$refs['pageForm'].formData.contact,
          querystring.stringify({'contact': JSON.stringify(temp)}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          data.contact1 = response.data;
          this.upsertContactComplete(data, `Successfully update ${this.$refs['pageForm'].formData.name} contact information`);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', 'contact information'));
        })
    },
    upsertContactComplete(data, message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.upsertData(data);
    },

    upsertData(data) {
      if(this.$refs['pageForm'].formIsAdd) {
        this.addData(data);
      } else {
        this.editData(data);
      }
    },
    async addData(data) {
      let formData = this.$refs['pageForm'].formData
      let feedbackItem = formData.name;

      // let temp = {};
      // temp['name'] = formData.companyPICname;
      // temp['email'] = formData.companyPICemail;
      // temp['mobile'] = formData.companyPICphone;

      // this.$refs['pageFeedback'].setFeedbackLoading('Adding user ' + feedbackItem);
      // let addUserResult = await this.$http
      //     .post(
      //       helper.API_URL + '/api2/auth2/web/register',
      //       querystring.stringify(temp),
      //       helper.createAxiosConfig()
      //     )
      //     .then(response => {
      //     let resultMeta = helper.processAxiosResponse(this, response);
      //       return response.data;
      //       // this.upsertDataComplete('Successfully added internal user ' + feedbackItem);
      //     })
      //     .catch(error => {
      //       this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding user', feedbackItem));
      //     })

      // if(!addUserResult) {
      //   return;
      // }

      let url = helper.SERVER_URL +  this.API_PATH;
      formData['isCompany'] = 1;
      // formData['userID'] = addUserResult['userID'];
      formData['address1'] = data['address1'];
      formData['contact1'] = data['contact1'];
      
      this.$refs['pageFeedback'].setFeedbackLoading('Adding profile ' + feedbackItem);
      this.$http
        .post(
          url,
          querystring.stringify(formData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          data.customer = response.data[0];

          if(helper.checkRoleIsParker()) {
            this.processForParker(response, data);
            return;
          }

          this.upsertDataComplete('Verification email has been sent to ' + formData['companyPICemail'], data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    async processForParker(response, data) {
      let meRoles = JSON.parse(localStorage.getItem('meRoles') || '[]');
      let parkerRole = meRoles.find(k => k.roleID === 20000);
      let customerID = (((response || {}).data || [])[0] || {}).id || 1;
      parkerRole.customerID = customerID;
      localStorage.setItem('selectedCustomerID', customerID);
      parkerRole.rules = JSON.stringify(helper.createParkerRules());
      localStorage.setItem('meRoles', JSON.stringify(meRoles));

      this.upsertDataComplete('Successfully added profile', data);
    },
    editData(data) {
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + this.$refs['pageForm'].formData.name);

      let url = helper.SERVER_URL +  this.API_PATH + this.$refs['pageForm'].formData.id;
      this.$refs['pageForm'].formData.address1 = data.address1;
      this.$refs['pageForm'].formData.contact1 = data.contact1;

      this.$http
        .put(
          url,
          querystring.stringify(this.$refs['pageForm'].formData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          data.customer = response.data[0];
          this.upsertDataComplete('Successfully updated ' + this.$refs['pageForm'].formData.name, data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    async upsertDataComplete(message, data) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);

      if(message.includes('Verification email')) {
        await new Promise(resolve => setTimeout(resolve, 3000));
      }
      
      if(this.$route.query.redirect) {
        // helper.redirect({ path: 'companyParker', query: { customerID: data.customer.id, redirect: this.$route.query.redirect }});
        helper.redirect(this.$route.query.redirect);
      } else {
        helper.redirect(helper.WEB_URL + '/company');
      }
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'companyAddressCityID') {
        this.onFormCompanyCityChange();
      }
    },
    onFormCompanyCityChange() {
      let formData = this.$refs['pageForm'].formData;
      formData['companyAddressStateID'] = null;
      formData['companyAddressCountryID'] = null;
      
      let selectedCity = helper.inputSelectFindOption(PARAM_MAP['companyAddressCityID'], formData['companyAddressCityID']);
      if(!selectedCity) {
        return;
      }

      let selectedState = helper.inputSelectFindOption(PARAM_MAP['companyAddressStateID'], selectedCity.stateID);
      if(!selectedState) {
        return;
      }
      formData['companyAddressStateID'] = selectedState.id;
      
      let selectedCountry = helper.inputSelectFindOption(PARAM_MAP['companyAddressCountryID'], selectedState.countryID);
      if(!selectedCountry) {
        return;
      }
      formData['companyAddressCountryID'] = selectedCountry.id;
    },

    hasAddOrEditPermission() {
      if(this.pageIsAdd) {
        return helper.hasAddPermission(this.permission);
      } else {
        return helper.hasEditPermission(this.permission);
      }
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PageCompanyForm.vue